import { CircleAlertIcon, XIcon } from "lucide-react";
import { Button } from "react-aria-components";
import { twMerge } from "tailwind-merge";

type BannerVariant = "info";

type BannerProps = {
  actions?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  onClose?: () => void;
  title: string;
  variant: BannerVariant;
};

const variantConfig = {
  info: {
    icon: CircleAlertIcon,
    iconColor: "text-fg-error-primary",
  },
};

export function Banner({
  actions,
  children,
  className,
  onClose,
  title,
  variant,
}: BannerProps) {
  const config = variantConfig[variant];
  const Icon = config.icon;

  return (
    <div
      className={twMerge(
        "relative flex w-full items-start gap-xl rounded-xl bg-bg-primary-alt p-xl shadow-xs ring-1 ring-border-primary ring-inset",
        className,
      )}
    >
      <Icon className={twMerge("shrink-0", config.iconColor)} />
      <div className="flex min-w-0 flex-1 flex-col gap-lg">
        <div className="flex flex-col gap-xs">
          <p className="pr-4xl text-sm font-semibold text-text-secondary">
            {title}
          </p>
          {children}
        </div>
        {actions && <div className="flex items-start gap-lg">{actions}</div>}
      </div>
      {onClose && (
        <Button
          aria-label="Close"
          className="absolute right-[7px] top-[7px] grid size-9 place-items-center rounded-md p-md text-fg-quinary outline-hidden hover:bg-bg-primary-hover"
          onPress={onClose}
        >
          <XIcon className="shrink-0" size={20} />
        </Button>
      )}
    </div>
  );
}
